/* eslint no-param-reassign: "error" */

export default {
  SET_ALL_PAYMENT_TYPES(state, data) {
    state.paymentTypes = data;
  },

};
